/* eslint-disable symbol-description */
import { InjectionKey, Ref } from 'vue';
import { CreateUserModelIdentifier } from '@/ui/components/user/CreateUserModal';
import { FormItemFilterRecord, ReportRecordData, ReportWidget } from '@/services/api/resources/analytics-builder/model';

const isLowQualityImagesFromReportPageKey = Symbol() as InjectionKey<boolean>;
const createUserIdentifierFromActionPageKey = Symbol() as InjectionKey<CreateUserModelIdentifier>;
const reportIdFromAnalyticsPageKey = Symbol() as InjectionKey<Ref<number | undefined>>;
const reportFromAnalyticsPageKey = Symbol() as InjectionKey<Ref<ReportRecordData>>;
const selectedWidgetFromAnalyticsPageKey = Symbol() as InjectionKey<Ref<ReportWidget | null>>;
const isGuestFromAnalyticsPageKey = Symbol() as InjectionKey<boolean>;
const formItemDetailsFromWidgetKey = Symbol() as InjectionKey<Ref<FormItemFilterRecord | undefined>>;

export {
  isLowQualityImagesFromReportPageKey,
  createUserIdentifierFromActionPageKey,
  reportIdFromAnalyticsPageKey,
  reportFromAnalyticsPageKey,
  selectedWidgetFromAnalyticsPageKey,
  formItemDetailsFromWidgetKey,
  isGuestFromAnalyticsPageKey,
};
